import { Colors, Shadows, Typography } from '@zapier/design-system';
import { css } from '@emotion/react';
import { mediaQueries } from '@zapier/identity-utils';
import { OpenAILogo } from './OpenAILogo';

const rootStyles = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const headerStyles = css`
  ${Typography.pageHeader7}
  color: ${Colors.neutral800};
  margin-bottom: 30px;
  margin-top: 30px;
  text-align: left;

  ${mediaQueries.tablet} {
    padding-right: 50px;
  }

  ${mediaQueries.desktop} {
    ${Typography.pageHeader5}
  }
`;

const descriptionStyle = css`
  ${Typography.paragraph3}
  color: ${Colors.neutral700};
  margin-bottom: 30px;
  text-align: left;

  ${mediaQueries.tablet} {
    padding-right: 50px;
  }

  ${mediaQueries.desktop} {
    ${Typography.paragraph1Short}
  }
`;

const iconStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 40px;
  width: 40px;
  padding: 10px;
  border: 1px solid ${Colors.neutral300};
  box-shadow: ${Shadows.elevation5};

  ${mediaQueries.tablet} {
    height: 60px;
    width: 60px;
  }
`;

export function NLASignUpPromo() {
  return (
    <div css={rootStyles}>
      <div css={iconStyle}>
        <OpenAILogo />
      </div>
      <h3 css={headerStyles}>
        Unlock the power of ChatGPT with over 5,000 apps
      </h3>
      <p css={descriptionStyle}>
        Create your free account to connect your apps and manage what actions
        you can take within ChatGPT.
      </p>
    </div>
  );
}
